import { Skeleton } from '@mui/material';
import { FC } from 'react';
import styles from './DataGridPlaceholder.module.scss';

export const DataGridPlaceholder: FC = () => (
    <div
        className={styles.DataGridPlaceholder}
        data-testid="DataGridPlaceholder"
    >
        {[...Array(40)].map((_, index) => (
            <Skeleton key={index} />
        ))}
    </div>
);
